import { render, staticRenderFns } from "./DeviceTypeEdit.vue?vue&type=template&id=c72ce3f2&scoped=true"
import script from "./DeviceTypeEdit.vue?vue&type=script&lang=js"
export * from "./DeviceTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./DeviceTypeEdit.vue?vue&type=style&index=0&id=c72ce3f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72ce3f2",
  null
  
)

export default component.exports